import { render, staticRenderFns } from "./RcvScL_List.vue?vue&type=template&id=8a35b066"
import script from "./RcvScL_List.vue?vue&type=script&lang=js"
export * from "./RcvScL_List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports